import * as React from 'react';

const ChevronLeftBlackSvg = props => (
    <svg width={16} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10 5.167v6.667L6.667 8.5 10 5.167Z" fill="#111" />
    </svg>
);

export default ChevronLeftBlackSvg;
